export enum MenuStatus {
    Available = "available",
    Inactive = "inactive",
    Unavailable = "unavailable",
}
